/* eslint-disable max-params */
/* eslint-disable max-len */
import {
    fetchSearchResultsFromAPI,
    fetchSearchVerticalsFromAPI,
    fetchTagsFromAPI,
    fetchTagFromAPI,
    setUrl
} from '../methods';

import {
    filterActions,
    mapActions,
    uiActions
} from '../actions';

import { addViewItemListDataLayer } from '../dataLayerEvents';

const Promise = require('bluebird');

const fetchActions = {
    requestSearchResults: () => ({
        type: 'REQUEST_SEARCH_RESULTS'
    }),
    receiveSearchResults: response => ({
        type: 'RECEIVE_SEARCH_RESULTS',
        payload: {
            response
        }
    }),
    fetchSearchResults: (apiUrl, userLang, location, tag, params, trackingCookieId, shouldSetUrl = false, locationChanged = false, fromCache = false) => {
        return (dispatch, getState) => {
            if (location !== null && tag !== null && params !== null && trackingCookieId !== null) {
                if (shouldSetUrl) {
                    setUrl(apiUrl, userLang, location, tag, params, null, false);
                }
                const state = getState();
                dispatch(uiActions.toggleContentLoading(true));
                dispatch(fetchActions.requestSearchResults());
                return fetchSearchResultsFromAPI(state, userLang, location, tag, params, trackingCookieId, state.user.adminModeId, state.user.isAdmin, fromCache)
                    .then(response => {
                        if (locationChanged) {
                            dispatch(mapActions.setRequiresRefitAndMapUnstable());
                        }
                        dispatch(fetchActions.receiveSearchResults(response));
                        if (shouldSetUrl) {
                            setUrl(apiUrl, userLang, location, tag, params, response.search.token);
                        }
                        if (locationChanged) {
                            dispatch(mapActions.unsetRequiresRefit());
                        }
                        dispatch(filterActions.updateSliderText());
                        dispatch(uiActions.initialContentLoaded());
                        dispatch(uiActions.toggleContentLoading(false));
                        addViewItemListDataLayer(response.results);
                        $(window).scrollTop(0);
                    })
                    .catch(console.log);
            } else {
                return Promise.resolve();
            }
        };
    },
    requestTags: () => ({
        type: 'REQUEST_TAGS'
    }),
    receiveTags: tags => ({
        type: 'RECEIVE_TAGS',
        payload: {
            tags
        }
    }),
    fetchTags: config => {
        return dispatch => {
            dispatch(fetchActions.requestTags());
            return fetchTagsFromAPI(config)
                .then(tags => {
                    dispatch(fetchActions.receiveTags(tags));
                });
        };
    },
    requestTag: () => ({
        type: 'REQUEST_TAG'
    }),
    receiveTag: tag => ({
        type: 'RECEIVE_TAG',
        payload: {
            tag
        }
    }),
    fetchTag: (config, tagSlug) => {
        return dispatch => {
            dispatch(fetchActions.requestTag());
            return fetchTagFromAPI(config, tagSlug)
                .then(tag => {
                    dispatch(fetchActions.receiveTag(tag));
                });
        };
    },
    requestSearchVerticals: () => ({
        type: 'REQUEST_SEARCH_VERTICALS'
    }),
    receiveSearchVerticals: verticals => ({
        type: 'RECEIVE_SEARCH_VERTICALS',
        payload: {
            verticals
        }
    }),
    fetchSearchVerticals: config => {
        return dispatch => {
            dispatch(fetchActions.requestSearchVerticals());
            return fetchSearchVerticalsFromAPI(config)
                .then(verticals => {
                    dispatch(fetchActions.receiveSearchVerticals(verticals));
                });
        };
    }
};

export default fetchActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/fetchActions.js